// src/store/slices/themeSlice.js
import { createSlice } from '@reduxjs/toolkit';

const getInitialTheme = () => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
        return savedTheme;
    }

    // Check system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
};

const initialState = {
    mode: getInitialTheme(),
    primaryColor: '#1890ff',
    borderRadius: 6,
    fontFamily: 'Open Sans, sans-serif',
    direction: 'ltr',
    compactMode: false,
    sidebarBg: '#ffffff',
    headerBg: '#ffffff',
    contentBg: '#f5f5f5'
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        toggleTheme: (state) => {
            state.mode = state.mode === 'light' ? 'dark' : 'light';
            localStorage.setItem('theme', state.mode);

            // Apply theme to document
            document.documentElement.setAttribute('data-theme', state.mode);
        },
        setTheme: (state, action) => {
            state.mode = action.payload;
            localStorage.setItem('theme', state.mode);
            document.documentElement.setAttribute('data-theme', state.mode);
        },
        setPrimaryColor: (state, action) => {
            state.primaryColor = action.payload;
        },
        setBorderRadius: (state, action) => {
            state.borderRadius = action.payload;
        },
        setFontFamily: (state, action) => {
            state.fontFamily = action.payload;
        },
        setDirection: (state, action) => {
            state.direction = action.payload;
            document.documentElement.setAttribute('dir', state.direction);
        },
        toggleCompactMode: (state) => {
            state.compactMode = !state.compactMode;
        },
        setCompactMode: (state, action) => {
            state.compactMode = action.payload;
        },
        setSidebarBg: (state, action) => {
            state.sidebarBg = action.payload;
        },
        setHeaderBg: (state, action) => {
            state.headerBg = action.payload;
        },
        setContentBg: (state, action) => {
            state.contentBg = action.payload;
        },
        resetTheme: (state) => {
            Object.assign(state, initialState);
            state.mode = getInitialTheme();
            localStorage.setItem('theme', state.mode);
            document.documentElement.setAttribute('data-theme', state.mode);
        }
    }
});

export const {
    toggleTheme,
    setTheme,
    setPrimaryColor,
    setBorderRadius,
    setFontFamily,
    setDirection,
    toggleCompactMode,
    setCompactMode,
    setSidebarBg,
    setHeaderBg,
    setContentBg,
    resetTheme
} = themeSlice.actions;

export default themeSlice.reducer;
